import { createLucideIcon } from "lucide-react";

export const UserBlock = createLucideIcon(
    "UserBlock",
    [
        [
            "path",
            {
                d: "M13 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453365 18.0441 4.1628 16.324 5.57757 15.4816C7.97679 14.053 10.8425 13.6575 13.5 14.2952",
                key: "1bklqt",
            },
        ],
        [
            "path",
            {
                d: "M16.05 16.05L20.95 20.95",
                key: "lfxaxn",
            },
        ],
        [
            "path",
            {
                d: "M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z",
                key: "155e3c",
            },
        ],
        [
            "path",
            {
                d: "M22 18.5C22 16.567 20.433 15 18.5 15C16.567 15 15 16.567 15 18.5C15 20.433 16.567 22 18.5 22C20.433 22 22 20.433 22 18.5Z",
                key: "4dtf0f",
            },
        ],
    ],
);
